import type { SelfDescribingJson } from '@snowplow/browser-tracker';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Placement, ProductType } from '../types';

type Action = 'hide' | 'display';

export function productTypeToReflexive(
  productType: ProductType,
): 'health' | 'medicare' {
  return productType === 'HEALTH' ? 'health' : 'medicare';
}

export interface ComponentImpressionData {
  component: string;
  action: Action;
  category: Placement | 'WIDGET';
  product: ProductType;
  list_position?: number;
  list_page?: number;
  list_total?: number;
}

export function trackComponentImpression(
  eventData: ComponentImpressionData,
  contexts?: SelfDescribingJson[] | null,
): void {
  trackSelfDescribingEvent({
    event: {
      schema: 'iglu:com.healthcare/component_impression/jsonschema/1-1-0',
      data: {
        component: eventData.component,
        category: eventData.category.toLocaleLowerCase(),
        action: eventData.action,
        product: productTypeToReflexive(eventData.product),
        list_position: eventData.list_position,
        list_page: eventData.list_page,
        list_total: eventData.list_total,
      },
    },
    context: contexts,
  });
}
